import React from "react";

/**
 * Shared print styles component used across legislation pages
 * Ensures consistent print styling and prevents duplication
 */
const PrintStyles: React.FC = () => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
            /* Default: hide print-only content on screen */
            .print-only { display: none; }

            @media print {
              /* Show print-only content when printing */
              .print-only { display: block !important; }
              /* Hide explicitly marked UI */
              .no-print { display: none !important; }
              /* Hide app header */
              header { display: none !important; }

              /* Ensure white background and accurate colors */
              .print-bg { background: white !important; }
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }

              /* Hide scrollbars in print */
              html, body, * {
                overflow: visible !important;
                overflow-x: visible !important;
                overflow-y: visible !important;
              }
              html::-webkit-scrollbar,
              body::-webkit-scrollbar,
              *::-webkit-scrollbar {
                display: none !important;
                width: 0 !important;
                height: 0 !important;
              }
              html {
                -ms-overflow-style: none !important;
                scrollbar-width: none !important;
              }
              body {
                -ms-overflow-style: none !important;
                scrollbar-width: none !important;
              }

              /* The app shell is a viewport-sized, scroll-clipped chrome. Left as-is
                 it cuts the printed output off after the first page, so put the whole
                 chain back into normal flow before the document itself is reset.

                 min-width: 0 is the horizontal twin: the overflow reset above
                 re-arms the flexbox automatic minimum size on the shell's flex
                 items, so a fixed pixel width inside the document would become
                 the shell's content-based minimum and inflate the printed layout
                 past the paper, cropping its right edge (LAR-396). */
              html, body, #root, [data-slot="sidebar-wrapper"],
              [data-slot="sidebar-inset"], [data-content-scroll="true"] {
                height: auto !important;
                min-height: 0 !important;
                max-height: none !important;
                min-width: 0 !important;
                overflow: visible !important;
              }
              [data-content-scroll="true"] { display: block !important; }

              /* Off-canvas navigation is position: fixed and would otherwise paint
                 over the first printed page. */
              [data-slot="sidebar"] { display: none !important; }

              /* Same for toasts, which sonner renders at body level: the print
                 helper shows progress while it loads the page rasters, and warns
                 before opening the dialog when some of them failed. */
              [data-sonner-toaster] { display: none !important; }

              /* On-screen zoom must not scale or narrow the printed page. */
              .doc-root {
                transform: none !important;
                zoom: 1 !important;
                width: 100% !important;
              }

              /* Reset layout constraints so the whole document prints (not just viewport) */
              .print-reset, .print-reset * {
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
                position: static !important;
                transform: none !important;
                contain: none !important;
              }

              /* Optional: better page size */
              @page { 
                size: A4; 
                margin: 15mm 10mm 15mm 10mm; /* top right bottom left */
              }
            }
          `,
      }}
    />
  );
};

export default PrintStyles;
